import React from 'react';
import Link from 'gatsby-link';
import styles from "../css/about.css";

const About = () => (
    <div id="about-page">
        <section className="pageHeader" id="about-header">
            <div className="container py-5">
                <h1>About Us</h1>
            </div>
        </section>
        <section className="container small-container text-center">
            <div className="row">
                <div className="col-12 text-left ">
                    <h2>
                        The Start
                    </h2>
                    <p>
                        A software development company founded in Kent UK by a team of creative designers & skilled developers.
                    </p>
                </div>

                <div className="col-12">
                    <hr />
                </div>

                <div className="col-12 text-right ">
                    <h2>
                        Our Product
                    </h2>
                    <p>
                        We develop for the web, iOS, Android & Windows.
                    </p>
                </div>

                <div className="col-12">
                    <hr />
                </div>

                <div className="col-12 text-left ">
                    <h2>
                        Our Quality
                    </h2>
                    <p>
                        Over time we have assembled a compact but powerful team of
                        developers who aim to create nothing short of beautiful products.
                    </p>
                </div>
            </div>
        </section>
    </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.js